module.exports = __webpack_public_path__ + "img/Weapon_85.d24ea63d.png";